import React, { useState } from 'react';
import { fetchApi } from '../../services/api';
import LoadingPanel from '../../components/LoadingPanel';
import { Input } from '@progress/kendo-react-inputs';
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import { Button } from '@progress/kendo-react-buttons';
import { JsonResponse } from 'TypeGen/json-response';

type SaveRequest = {
  ExternalUrl: string;
}

type Props = {
  TripID: number;
  ExternalUrl: string;
  CloseDialog: () => void;
}

const ExternalUrl: React.FC<Props> = ({ TripID, ExternalUrl: initialUrl, CloseDialog }) => {
  const [loading, setLoading] = useState(false);
  const [request, setRequest] = useState<SaveRequest>({ ExternalUrl: initialUrl || '' });

  const updateRequest = (value: Partial<SaveRequest>) => {
    setRequest((prev) => ({ ...prev, ...value }));
  };

  const save = () => {
    setLoading(true);
    fetchApi(`/api/Track/SaveExternalUrl/${TripID}`, request, 'POST')
      .then((response: JsonResponse) => {
        if (response.Success) {
          CloseDialog();
        } else {
          alert(response.ErrorMessage);
        }
      })
      .catch((e) => {
        if (!e?.status) alert('Unable to save the external url!');
      })
      .finally(() => {
        setLoading(false);
      });
  };

  if (loading) {
    return (
      <React.Fragment>
        <div className="k-overlay" style={{ zIndex: 10002, opacity: 0.5 }} />
        <LoadingPanel />
      </React.Fragment>
    );
  }

  return (
    <Dialog title="External Tracking URL" onClose={CloseDialog} className="dialog-w1140">
      <Input
        autoFocus
        label="Tracking URL"
        placeholder="https://..."
        type="url"
        validationMessage="Please enter a valid url!"
        style={{ width: '100%' }}
        value={request.ExternalUrl}
        onChange={(e) => updateRequest({ ExternalUrl: e.value })}
      />
      <DialogActionsBar layout="end">
        <Button onClick={CloseDialog}>Cancel</Button>
        <Button themeColor="primary" onClick={save} disabled={loading}>Save</Button>
      </DialogActionsBar>
    </Dialog>
  );
}

export default ExternalUrl;
